import { useAppSelector } from '../../../../app/hooks';
import { CubeMeasureEnum } from '../../../../services/data/impl/cube/cubeSlice';
import { isBlueberryFeature } from '../../../../services/data/impl/cube/cubeUtils';
import {
  RanchPageViewEnum,
  selectRanchPageView,
} from '../../../ranches/ranchesSlice';
import {
  selectCurrFeature,
  selectCurrMeasure,
  selectCurrScanID,
} from '../../../select/selectSlice';
import { LayerEnum, selectLayerVisibility } from '../../mapSlice';
import BlueberryLegend from './Blueberry Legend';
import HeatmapLegend from './HeatmapLegend';
import LegendWrapper from './LegendWrapper';
import RanchSummaryLegend from './RanchSummaryLegend';

interface Props {
  height: number;
}

const MapLegend: React.FC<Props> = ({ height }) => {
  const layerVisibility = useAppSelector(selectLayerVisibility);
  const currScanID = useAppSelector(selectCurrScanID);
  const currFeature = useAppSelector(selectCurrFeature);
  const currMeasure = useAppSelector(selectCurrMeasure);
  const ranchPageView = useAppSelector(selectRanchPageView);

  let legendContent = null;

  /**
   * Function to determine whether Heatmap or HexHeatmap layer is visible
   * @returns boolean
   */
  const isHeatmapVisible = () => {
    return layerVisibility[LayerEnum.heatmap];
  };

  if (
    ranchPageView === RanchPageViewEnum.blockDetail &&
    currScanID &&
    isHeatmapVisible()
  ) {
    if (isBlueberryFeature(currFeature)) {
      legendContent = <BlueberryLegend />;
    } else if (
      currMeasure === CubeMeasureEnum.DetectionFactAvgLength ||
      currMeasure === CubeMeasureEnum.detectionFactAvgCountPerMeter
    ) {
      legendContent = <HeatmapLegend />;
    }
  } else if (ranchPageView === RanchPageViewEnum.ranchSummary) {
    legendContent = <RanchSummaryLegend />;
  }

  return (
    legendContent && (
      <LegendWrapper mapHeight={height}>{legendContent}</LegendWrapper>
    )
  );
};

export default MapLegend;
